import React from 'react';
import { useRef, useEffect, useState } from 'react';

export default function Slider({ title, onChangeValue, value }) {
  // const [value, setValue] = useState(20);
  const handleChange = (event) => {
    // setValue(event.target.value);
    onChangeValue(event.target.value, title);
  };
  const map = {
    0: 'خیلی بد',
    5: 'بد',
    10: 'معمولی',
    15: 'خوب',
    20: 'عالی',
  };

  return (
    <>
      <div className="tick-slider mb-3">
        <div className="rating-title">
          <div className="tick-slider-header">
            <span className="text-sm">{title}</span>
          </div>
          <div className="tick-slider-value-container">
            <div id="LabelMin" className="tick-slider-label">
              1
            </div>
            <div id="LabelMax" className="tick-slider-label">
              5
            </div>
            <div id="Value" className="tick-slider-value">
              <div>{map[value]}</div>
            </div>
          </div>
        </div>
        <div className="review-input">
          <div className="tick-slider-background"></div>
          <div
            id="Progress"
            className="tick-slider-progress"
            style={{ width: `${value * 5}%` }}
          ></div>
          <div id="Ticks" className="tick-slider-tick-container">
            <span className="tick-slider-tick on"></span>
            <span className="tick-slider-tick on"></span>
            <span className="tick-slider-tick on"></span>
            <span className="tick-slider-tick"></span>
            <span className="tick-slider-tick"></span>
          </div>
          <input
            id="Slider"
            name="Slider"
            className="tick-slider-input"
            type="range"
            min="0"
            max="20"
            step="5"
            value={value}
            onChange={handleChange}
            data-tick-step="5"
            data-tick-id="Ticks"
            data-value-id="Value"
            data-progress-id="Progress"
            data-handle-size="18"
            data-min-label-id="LabelMin"
            data-max-label-id="LabelMax"
          />
        </div>
      </div>
    </>
  );
}
